import styled from 'styled-components';
import StyledContainer from 'containers/Container';
import {transparentize} from 'polished';
import {Container as BaseButton} from "components/Button";

export const Label = styled.span`
  margin-top: 10px; 
  margin-bottom: 20px;
  display: block;
  line-height: 18px;
  font-size: 14px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
`;

export const BannerWrapper = styled.div`
  position: relative;
  padding: 20px;
  border-radius: 5px;
  background: ${({theme}) => theme.variables.accentBackgroundColor};
`;

export const BannerTitle = styled.div`
  position: absolute;
  padding: 40px;
  max-width: 538px;
  font-size: 46px;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 0.01em;
  color: ${({theme}) => theme.variables.color};
`;

export const BannerPlay = styled.div`
  position: absolute;
  top: calc(50% - 65px);
  left: calc(50% - 65px);
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background-image: url("data:image/svg+xml,%3Csvg width='130' height='130' viewBox='0 0 130 130' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='65' cy='65' r='65' fill='%233264EF'/%3E%3Cpath d='M80.2969 65.0012L57.3557 78.2462L57.3557 51.7561L80.2969 65.0012Z' fill='white'/%3E%3C/svg%3E%0A");
  cursor: pointer;
  transition: box-shadow .3s;
  
  &:hover {
    box-shadow: 0 0 10px #007aff;
  }
`

export const Content = styled.div`
  display: grid;
  gap: 20px;
`

export const ContentSection = styled.section`
  padding: 20px;
  border-radius: 5px;
  background: ${({theme}) => theme.variables.accentBackgroundColor};
`

export const ContentLabel = styled.div`
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 13px;
  letter-spacing: 0.03em;
  text-align: left;
  text-transform: uppercase;
  margin-bottom: 20px;
  
  color: ${({theme}) => `
    ${transparentize(.7, theme.variables.color)};
  `};
`

export const Files = styled.div`
  display: grid;
  gap: 16px;
`

export const FileBox = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 16px;
  align-items: center;
  width: max-content;
  cursor: pointer;
  
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0.01em;

  &:hover {
    color: ${({theme}) => theme.colors.primaryLight};
  }
`

export const Button = styled(BaseButton)`
  border-radius: 5px;
  padding: 0 24px;
  height: 44px;
  box-sizing: border-box;
  cursor: pointer;
`

export const Footer = styled(StyledContainer)`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(2, max-content);
  gap: 10px;
  margin-top: 30px;
  margin-bottom: 80px;
`